import Vue from 'vue'
import store from '~/store'
import router from '~/router'
import App from '~/components/App'
const VueInputMask = require('vue-inputmask').default;
const numeral = require("numeral");
require("numeral/locales/ru")
numeral.locale('ru');
import ElementUI from 'element-ui';
import lang from 'element-ui/lib/locale/lang/ru-RU'
import locale from 'element-ui/lib/locale'
import Vuesax from 'vuesax'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

import '~/plugins'
import '~/components'

import "./modules/bootstrap";
import "./modules/theme";
// import "./modules/dragula";
import "./modules/feather";
import "./modules/moment";
import "./modules/sidebar";
import "./modules/toastr";
import "./modules/user-agent";
// import "./modules/chartjs";
// import "./modules/apexcharts";
import "./modules/daterangepicker";
import "./modules/datetimepicker";
// import "./modules/fullcalendar";
// import "./modules/markdown";
import "./modules/mask";
import "./modules/quill";
import "./modules/select2";
import "./modules/validation";
import "./modules/wizard";
import axios from "axios";
// import "./modules/vector-maps";
// import "./modules/datatables";
import "./modules/functions";

Bugsnag.start({
    apiKey: '5fb617d4aef777a65fb1da266c992de0',
    plugins: [new BugsnagPluginVue()],
    appVersion: process.env.MIX_APP_BUILD,
    onError: (event) => {
        const err = event.originalError

        // Достаём статус HTTP максимально надёжно (axios)
        const status =
            err?.response?.status ??
            err?.status ??
            err?.request?.status ??
            null

        const message = String(err?.message || '')

        // 1) Network Error (axios) / офлайн / проблемы сети
        // axios: message === "Network Error" и response обычно отсутствует
        if (message === 'Network Error' || (status === 0 && !err?.response)) {
            return false
        }

        // 2) 401 — истекла сессия и т.п.
        if (status === 401) {
            return false
        }

        // 3) 422 — ошибки валидации
        if (status === 422) {
            return false
        }

        if (message === 'Cannot read properties of undefined (reading \'destroy\')') {
            return false;
        }

        return true
    },
})
const bugsnagVue = Bugsnag.getPlugin('vue')
bugsnagVue.installVueErrorHandler(Vue)

Vue.use(Vuesax);
store.dispatch('auth/initLastReload')

import Echo from "laravel-echo"
import RoleData from "./plugins/role_data";
window.io = require('socket.io-client');
if (typeof io !== 'undefined') {
    let echo_host = process.env.MIX_ECHO_HOST ? process.env.MIX_ECHO_HOST : window.location.hostname;
    window.Echo = new Echo({
        broadcaster: 'socket.io',
        host: echo_host + ':6001',
        auth: {
            headers: {
                Authorization: store.getters['auth/token'] ? `Bearer ${store.getters['auth/token']}` : null,
                'X-APP-BUILD': process.env.MIX_APP_BUILD,
                'X-APP-LAST-RELOAD': store.getters['auth/last_reload'] ? store.getters['auth/last_reload'] : '',
                'X-APP-UA': window.navigator.userAgent,
            }
        }
    });
}

locale.use(lang);
Vue.use(ElementUI);

Vue.config.productionTip = false;
Vue.use(VueInputMask);
Vue.prototype.$bus = new Vue();



Vue.directive('scroll', {
    inserted: function (el, binding) {
        let f = function (evt) {
            if (!binding.value(evt, el)) {
                window.removeEventListener('scroll', f)
            }
        };
        window.addEventListener('scroll', f)
    }
});
Vue.directive('float', {
    inserted: function (el) {
        el.onkeypress = function (event) {
            return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 44 || event.charCode === 45 || event.charCode === 46 || event.charCode === 0;
        };
    }
})
Vue.directive('integer', {
    inserted: function (el) {
        el.onkeypress = function (event) {
            return (event.charCode >= 48 && event.charCode <= 57) || event.charCode === 0;
        };
    }
})
Vue.prototype.$hasPermission = function(name) {
    let user = this.$store.getters['auth/user'];
    return user && user.permission_names.indexOf(name) !== -1;
};
Vue.prototype.$hasPermissionInterface = function(name) {
    let user = this.$store.getters['auth/user'];
    return user && RoleData.hasPermissionInterface(user, name);
};
Vue.prototype.$hasRole = function(name) {
    let user = this.$store.getters['auth/user'];
    return user && user.role_names.indexOf(name) !== -1;
};
Vue.prototype.$copyToClipboard = function(value) {
    copyToClipboard(value);
};
Vue.prototype.$copyDateToClipboard = function (value, format = "YYYY-MM-DD") {
    copyToClipboard(moment(value).format(format));
};
Vue.prototype.$allowRequest = function (id) {
    let self = this;
    if (this.$hasRole('sales_manager')) {
        return axios.get('/api/requests/' + id + '/allow_request')
            .then(function (response) {
                self.$store.dispatch('auth/pushAllowedRequestsIds', id);
            });
    }
    return new Promise(function(resolve, reject) {resolve();});
};
Vue.prototype.$isAllowRequest = function (request) {
    if (this.$hasRole('sales_manager')) {
        if (this.$hasRole('head_of_sales_department')) return true;
        if (request.sales_manager_id) return true;
        let user = this.$store.getters['auth/user'];
        if (user && user.allowed_requests_ids && user.allowed_requests_ids.indexOf(request.id) !== -1) return true;
        return false;
    }
    return true;
};
Vue.prototype.$requestOpenDrawer = function (id) {
    this.$bus.$emit('request:open-drawer', id);
};
Vue.prototype.$userOpenModal = function (id) {
    this.$bus.$emit('user:open-modal', id);
};
Vue.prototype.$userOpenModalResetPassword = function (id) {
    this.$bus.$emit('user:open-modal-reset-password', id);
};
Vue.prototype.$userOpenModalFullData = function (id) {
    this.$bus.$emit('user:open-modal-full-data', id);
};
Vue.prototype.$counteragentLabel = function (c, use_year = false) {
    if (c.subject_type === 'company') return c.name;
    if (c.subject_type === 'person') return [c.last_name, c.first_name, c.middle_name, use_year ? (c.birthdate ? moment(c.birthdate).format('YYYY') + 'г.р.' : "") : ""].join(' ');
};
Vue.prototype.$hidePartPhone = function (number) {
    if (!number) return number;
    number = number.replace(/[^\+0-9]/g, '');
    return number.replace(/\+(\d)(\d{3})(\d)(\d)(\d)(\d)(\d)(\d)(\d)/, "+$1$2****$7$8$9")
};
Vue.prototype.$formatPhone = function (number) {
    number = number.replace(/[^\+\*0-9]/g, '');
    return number.replace(/\+(.)(.{3})(.)(.)(.)(.)(.)(.)(.)/, "+$1 ($2) $3$4$5-$6$7-$8$9")
};

Vue.filter("formatNumber", function (value) {
    return value === null ? null : new Intl.NumberFormat('ru-RU').format(value);
    // return numeral(value).format('0,0');
});

Vue.filter("formatMoneyRUB", function (value) {
    return value === null ? null : new Intl.NumberFormat('ru-RU').format(value) + " р.";
    // return numeral(value).format('0,0');
});

Vue.filter("formatDateDMY", function (value) {
    return moment(value).format('DD.MM.YYYY');
});
Vue.filter("formatDateDMYHi", function (value) {
    return moment(value).format('DD.MM.YYYY HH:mm');
});



/* eslint-disable no-new */
new Vue({
  store,
  router,
  ...App
});

